<template>
  <div class="coupon-detail">
    <ul v-if="coupon_detail.scope_type">
      <li>
        <span>优惠券名称：</span>
        <font>{{coupon_detail.name}}</font>
      </li>
      <li>
        <span>类型：</span>
        <font>{{coupon_detail.receive_type == 1 ? '领取':"赠送"}}</font>
      </li>
      <li>
        <span>使用范围：</span>
        <font>{{coupon_detail.scope_type_name}}</font>
      </li>
      <li>
        <span>优惠规则：</span>
        <font>满 {{coupon_detail.full_reduction/100}} 减 {{coupon_detail.discounted_price/100}}</font>
      </li>
      <li>
        <span>有效期：</span>
        <font>{{coupon_detail.valid_value}}</font>
      </li>
      <li>
        <span>发放数量：</span>
        <font>{{coupon_detail.num}}张</font>
      </li>
      <li>
        <span>每人限领：</span>
        <font>{{coupon_detail.restrict_num}}张</font>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      coupon_detail: "",
      scoped_type: ["所有课程", "【指定课程分类】", "【指定课程】"]
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    async getDetail() {
      const coupon_detail = await this.$http.get(
        `/api/coupon/${this.$route.query.id}`
      );
      coupon_detail.scope_type_name = this.$pub.getCouponUseRange(
        coupon_detail.dis_type,
        coupon_detail.scope_type,
        coupon_detail.commodity
      );

      if (coupon_detail.valid_type == 1) {
        coupon_detail.valid_value = coupon_detail.valid_day + "天";
      } else {
        coupon_detail.valid_value =
          this.$pub.timestampToDay(coupon_detail.valid_start) +
          "~" +
          this.$pub.timestampToDay(coupon_detail.valid_end);
      }
      this.coupon_detail = coupon_detail;
    }
  }
};
</script>

<style lang="scss" scoped>
.coupon-detail {
  padding: 20px 20px;
  ul {
    li {
      display: flex;
      font-size: 16px;
      font-family: "微软雅黑";
      color: #333;
      line-height: 36px;
      span {
        width: 120px;
        text-align: right;
      }
      font {
        margin-left: 10px;
      }
    }
  }
}
</style>
